import theme from 'config/theme';

export default {
  container: {
    width: '100%',
    borderRadius: 2,
    border: `1px solid ${theme.palette.grays.gray150}`,
    overflow: 'auto',
  },
};
